"use client";

import { SectionTitle } from "./sectionTitle";

export const Apply = () => {
	return (
		<div id="apply" className="flex flex-col gap-4">
			<SectionTitle title="運営" />

			<div className="flex items-center gap-4">
				<img
					src="/events/suzuka2025/prossell.svg"
					alt="Prossellロゴ"
					className="h-[98px] object-contain"
				/>
			</div>

			<p className="text-black font-bold font-zenMaru text-xl text-left">
				株式会社プロッセル
			</p>
		</div>
	);
};
